import platforms from './modules/platforms';
import targetBuilds from './modules/targetBuilds';
import testResults from './modules/testResults';
import logs from './modules/logs';
import authorization from './modules/authorization';
import xmlRequests from './modules/xmlRequests';

export default {
    platforms,
    targetBuilds,
    testResults,
    logs,
    authorization,
    xmlRequests,
};
